import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import OpenButton from "../../../ui/components/OpenButton/OpenButton";

import CreateDistributionPipelineForm from "../../../distribution/components/CreateDistributionPipelineForm/CreateDistributionPipelineForm";
import useDistributionChannelPipelinesTableColumns from "../../../distribution/hooks/useDistributionChannelPipelinesTableColumns";
import useDistributionPipelineDropdownMenuOptions from "../../../distribution/hooks/useDistributionPipelineDropdownMenuOptions";
import Table from "../../../tables/components/Table";

export default function SuperAdminDistributionChannelPipelinesView({ channel }) {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const data = Object.values(channel.pipelines || {});

	const columns = useDistributionChannelPipelinesTableColumns({ channel });
	const getDropdownMenuOptions = useDistributionPipelineDropdownMenuOptions({ channel });

	return (
		<>
			<Table
				data={data}
				columns={columns}
				onClick={({ id }) => navigate(id)}
				getDropdownMenuOptions={getDropdownMenuOptions}
			/>

			<OpenButton text={t("createPipeline", "Create pipeline")}>
				{({ setOpen }) => <CreateDistributionPipelineForm channel={channel} onClose={() => setOpen(false)} />}
			</OpenButton>
		</>
	);
}
